<template>
	<van-field
		class="audit-field"
		:value="value"
		:label="label"
		:required="required"
		:placeholder="placeholder || '请输入' + label"
		:readonly="readonly"
		:disabled="disabled"
		:is-link="isLink && !disabled"
		:maxlength="maxlength"
		input-align="right"
		:error="error"
		:error-message="errorMessage"
		@input="onInput"
		@click="onClick"
	/>
</template>

<script>
// 通用表单项（对应小程序 base-input）
export default {
	name: 'AuditField',
	props: {
		value: {
			type: [String, Number],
			default: '',
		},
		label: {
			type: String,
			default: '',
		},
		required: {
			type: Boolean,
			default: false,
		},
		placeholder: {
			type: String,
			default: '',
		},
		readonly: {
			type: Boolean,
			default: false,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
		isLink: {
			type: Boolean,
			default: false,
		},
		maxlength: {
			type: [Number, String],
			default: null,
		},
		error: {
			type: Boolean,
			default: false,
		},
		errorMessage: {
			type: String,
			default: '',
		},
	},
	methods: {
		onInput(val) {
			this.$emit('input', val)
		},
		onClick() {
			if (!this.disabled) this.$emit('click')
		},
	},
}
</script>

<style lang="less" scoped>
.audit-field {
	::v-deep .van-field__label {
		width: 96px;
		font-size: 14px;
		color: #1f2329;
	}

	::v-deep .van-field__value {
		font-size: 14px;
		color: #1f2329;
	}
}
</style>
